import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Divider,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dialog: {
    [theme.breakpoints.up("sm")]: {
      minWidth: "500px",
    },
  },
  content: {
    padding: theme.spacing(2),
  },
  label: {
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  value: {
    fontWeight: 400,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  gridItem: {
    marginBottom: theme.spacing(2),
  },
}));

const InvoiceDetailsDialog = ({ open, onClose, invoice, handlePayInvoice }) => {
  const classes = useStyles();

  if (!invoice) return null;

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <DialogTitle>Invoice Details</DialogTitle>
      <DialogContent className={classes.content}>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.gridItem}>
            <Typography variant="body2" className={classes.label}>
              Invoice ID
            </Typography>
            <Typography variant="body1" className={classes.value}>
              {invoice.provider_id || invoice.fees_id}
            </Typography>
          </Grid>

          <Grid item xs={12} className={classes.gridItem}>
            <Typography variant="body2" className={classes.label}>
              Description
            </Typography>
            <Typography variant="body1" className={classes.value}>
              {invoice.description}
            </Typography>
          </Grid>
          {invoice.total && (
            <Grid item xs={12} className={classes.gridItem}>
              <Typography variant="body2" className={classes.label}>
                Total Amount
              </Typography>
              <Typography variant="body1" className={classes.value}>
                {invoice.total}
              </Typography>
            </Grid>
          )}
          {invoice.percentage && (
            <Grid item xs={12} className={classes.gridItem}>
              <Typography variant="body2" className={classes.label}>
                Fee Percentage
              </Typography>
              <Typography variant="body1" className={classes.value}>
                {invoice.percentage}%
              </Typography>
            </Grid>
          )}
          <Grid item xs={6} className={classes.gridItem}>
            <Typography variant="body2" className={classes.label}>
              Fees
            </Typography>
            <Typography variant="body1" className={classes.value}>
              ${invoice.amount}
            </Typography>
          </Grid>

          <Grid item xs={6} className={classes.gridItem}>
            <Typography variant="body2" className={classes.label}>
              Status
            </Typography>
            <Typography variant="body1" className={classes.value}>
              {invoice.status}
            </Typography>
          </Grid>

          {invoice.date && (
            <Grid item xs={12} className={classes.gridItem}>
              <Typography variant="body2" className={classes.label}>
                Date
              </Typography>
              <Typography variant="body1" className={classes.value}>
                {new Date(invoice.date).toLocaleDateString()}
              </Typography>
            </Grid>
          )}

          {invoice.due_date && (
            <Grid item xs={12} className={classes.gridItem}>
              <Typography variant="body2" className={classes.label}>
                Due Date
              </Typography>
              <Typography variant="body1" className={classes.value}>
                {new Date(invoice.due_date).toLocaleDateString()}
              </Typography>
            </Grid>
          )}
        </Grid>

        {invoice.transactions && invoice.transactions.length > 0 && (
          <>
            <Divider className={classes.divider} />
            <Typography variant="subtitle2" gutterBottom>
              Transactions
            </Typography>
            {invoice.transactions.map((item, index) => (
              <Grid container spacing={2} key={index} className={classes.gridItem}>
                <Grid item xs={8}>
                  <Typography variant="body2">{item.public_transaction_id}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" align="right">
                    ${item.total_price}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </>
        )}
      </DialogContent>
      <DialogActions>
        {invoice.status !== "paid" && (
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              // Handle payment logic here
              handlePayInvoice(invoice);
              console.log("Process payment for invoice:", invoice.fees_id);
            }}
          >
            Pay Now
          </Button>
        )}
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceDetailsDialog;
